// Public routes
const publicRoutes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/public/estimates/:token',
    name: 'PublicEstimate',
    component: () => import('@/views/public/PublicEstimatePage.vue'),
    props: true,
    meta: {
      layout: 'public',
      title: 'Estimate'
    }
  },

  {
    path: '/profile',
    name: 'UserProfile',
    component: () => import('@/views/UserProfilePage.vue'),
    meta: {
      layout: 'default',
      title: 'User Profile',
      requiresAuth: true
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/UsersPage.vue'),
    meta: {
      layout: 'default',
      title: 'Users',
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/sell-sheet-templates',
    name: 'SellSheetTemplates',
    component: () => import('@/views/SellSheetTemplatesPage.vue'),
    meta: {
      layout: 'default',
      title: 'Sell Sheet Templates',
      requiresAuth: true,
      requiresRoles: ['super admin', 'admin']
    }
  },
  {
    path: '/sell-sheets',
    name: 'SellSheets',
    component: () => import('@/views/SellSheetsPage.vue'),
    meta: {
      layout: 'default',
      title: 'Sell Sheets',
      requiresAuth: true,
      requiresRoles: ['super admin', 'admin']
    }
  },
  {
    path: '/media',
    name: 'Media',
    component: () => import('@/views/MediaPage.vue'),
    meta: {
      layout: 'default',
      title: 'Media',
      requiresAuth: true,
      requiresRoles: ['super admin', 'admin', 'sales']
    }
  },
  {
    path: '/catalogue',
    name: 'Catalogue',
    component: () => import('@/views/CataloguePage.vue'),
    meta: {
      layout: 'default',
      title: 'Parts & Products',
      requiresAuth: true,
      requiresRoles: ['super admin', 'admin', 'sales']
    }
  },
  {
    path: '/quick-spire',
    name: 'QuickSpire',
    component: () => import('@/views/QuickSpirePage.vue'),
    meta: {
      layout: 'default',
      title: 'Quick Spire',
      requiresAuth: true,
      requiresRoles: ['super admin', 'admin', 'sales']
    }
  },
  {
    path: '/groups',
    name: 'Groups',
    component: () => import('@/views/GroupsPage.vue'),
    meta: {
      layout: 'default',
      title: 'Groups',
      requiresAuth: true,
      requiresRoles: ['super admin', 'admin', 'sales']
    }
  },
  {
    path: '/visual-merchandiser',
    name: 'VisualMerchandiser',
    component: () => import('@/views/StorefrontPage.vue'),
    meta: {
      layout: 'default',
      title: 'Visual Merchandiser',
      requiresAuth: true,
      requiresRoles: ['super admin', 'admin', 'sales']
    }
  },
  {
    path: '/pusher-pricer',
    name: 'PusherPricer',
    component: () => import('@/views/PusherPricerPage.vue'),
    meta: {
      layout: 'default',
      title: 'Pusher Pricer',
      requiresAuth: true,
      requiresRoles: ['super admin', 'admin', 'sales']
    }
  },
  {
    path: '/estimates',
    name: 'Estimates',
    component: () => import('@/views/EstimatesPage.vue'),
    meta: {
      layout: 'default',
      title: 'Estimates',
      requiresAuth: true,
      requiresRoles: ['super admin', 'admin', 'sales']
    }
  }
]

// Auth routes
const authRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginPage.vue'),
    meta: {
      layout: 'auth',
      title: 'Login',
      requiresGuest: true
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/auth/ForgotPasswordPage.vue'),
    meta: {
      layout: 'auth',
      title: 'Forgot Password',
      requiresGuest: true
    }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/auth/ResetPasswordPage.vue'),
    meta: {
      layout: 'auth',
      title: 'Reset Password',
      requiresGuest: true
    }
  }
]

// Error routes
const errorRoutes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFoundPage.vue'),
    meta: {
      layout: 'default',
      title: 'Page Not Found'
    }
  }
]

export const routes = [
  ...publicRoutes,
  ...authRoutes,
  ...errorRoutes
] 
